<div *ngIf="contentId" class="surveys-element-content-id">
    <p>{{ contentId }}</p>
</div>
